import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { LocalizedComponentClass, withLocalization } from 'bernie-l10n';

import { CarouselModel } from 'models';

import { UitkCarousel } from 'uitk-react-carousel';

import { CarouselCard } from './internals/carousel-card';
import { Lazy } from 'components/common/lazy/lazy';

export const SearchCarousel = withLocalization((props: CarouselModel) => {
  if (!props.model || !props.model.options) {
    return null;
  }
  const {
    model: { title, options },
    analytics,
    l10n,
    type,
    stidKey,
    className,
    lazyLoad
  } = props;
  const carouselProps = {
    itemsVisible: { lg: 3, md: 2, sm: 1 },
    pageBy: 1,
    peekWidth: 12,
    className: 'all-b-margin-three all-t-margin-three',
    carouselName: type,
    buttonText: {
      nextButton: l10n.formatText('carousel.nextItem'),
      prevButton: l10n.formatText('carousel.previousItem')
    }
  };

  React.useEffect(() => {
    if (analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent(`.${type}.Rendered`, `Showing ${type} module`, analytics.omnitureData);
    }
  }, []);

  function Standard() {
    return (
      <>
        {title && (
          <h3 className="uitk-type-500 all-t-margin-three" data-stid={`${stidKey}-title`}>
            {title}
          </h3>
        )}
        <UitkCarousel
          analytics={analytics && analytics.setupTracker(carouselProps.carouselName, 'Carousel interaction')}
          {...carouselProps}
        >
          {options.map((option, index) => option && <CarouselCard {...option} stidKey={stidKey} key={`${stidKey}-${index}`} />)}
        </UitkCarousel>
      </>
    );
  }

  function LazyCarousel() {
    return (
      <Lazy className={className}>
        <Lazy.Placeholder>
          <div data-stid={`${stidKey}-placeholder`} />
        </Lazy.Placeholder>
        <Lazy.Loaded>
          <Standard />
        </Lazy.Loaded>
      </Lazy>
    );
  }

  function RenderCarousel() {
    if (lazyLoad) {
      return <LazyCarousel />;
    }

    return <Standard />;
  }

  return (
    <ErrorBoundary label={stidKey}>
      <li className={className} data-stid={stidKey}>
        <RenderCarousel />
      </li>
    </ErrorBoundary>
  );
}) as LocalizedComponentClass<CarouselModel>;
